export const PLYWOOD_INVENTORY_REQUEST = "PLYWOOD_INVENTORY_REQUEST";
export const PLYWOOD_INVENTORY_SUCCESS = "PLYWOOD_INVENTORY_SUCCESS";
export const PLYWOOD_INVENTORY_FAILED = "PLYWOOD_INVENTORY_FAILED";

export const PLYWOOD_HISTORY_REQUEST = "PLYWOOD_HISTORY_REQUEST";
export const PLYWOOD_HISTORY_SUCCESS = "PLYWOOD_HISTORY_SUCCESS";
export const PLYWOOD_HISTORY_FAILED = "PLYWOOD_HISTORY_FAILED";
